import {
  UPDATE_THANKYOU_INITIAL_DATA,
  UPDATE_THANKYOU_DATA,
  UPDATE_THANKYOU_LOADING_STATUS
} from './constants';

export function updateInitialData({id}) {
  return {
    type: UPDATE_THANKYOU_INITIAL_DATA,
    id
  };
}

export function updateThankYouData(data, status) {
  return {
    type: UPDATE_THANKYOU_DATA,
    actionData: data,
    status
  };
}

export function setThankYouLoading(value: boolean) {
  return {
    type: UPDATE_THANKYOU_LOADING_STATUS,
    status: value,
  };
}
